import * as React from 'react';
import { Route, Redirect } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './components/Layout/Layout';
import './custom.css'
import Login from './components/Login/Login';
import AsphaltDashboard from './components/AsphaltDashboard/AsphaltDashboard';
import DeviceManagement from './components/AsphaltDashboard/DeviceManagement';
import DashboardSettings from './components/AsphaltDashboard/DashboardSettings';
import DisplayItemSetting from './components/AsphaltDashboard/DisplayItemSetting';
import LoadEdit from './components/AsphaltDashboard/LoadEdit';
import CancelEdit from './components/AsphaltDashboard/CancelEdit';

declare global {
    interface Window {
        google: any;
        initMap: any;
    }
}

export default () => {
  return (
    <Layout>
      {/* Sky72: トースト表示先をアプリ全体で1つに集約する。
          従来は Login 画面にしか ToastContainer が無く、ダッシュボード配下の画面
          （作業開始日時設定/表示項目設定/デバイス管理/積載量編集/出荷キャンセル）では
          「更新に成功。」「更新に失敗。」も入力エラーも一切表示されなかった。
          スタイル(ReactToastify.css)もどこからも読み込まれていなかったため併せて追加する。 */}
      <ToastContainer />
      {/* アスファルトダッシュボード: ルートは board へリダイレクト（fleet の地図/adminは使わない） */}
      <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
      <Route path="/login" component={Login} />
      <Route path="/admin" render={() => <Redirect to="/dashboard" />} />
      <Route exact path="/dashboard" component={AsphaltDashboard} />
      <Route path="/asphalt-devices" component={DeviceManagement} />
      <Route path="/asphalt-settings" component={DashboardSettings} />
      <Route path="/asphalt-display" component={DisplayItemSetting} />
      <Route path="/asphalt-load" component={LoadEdit} />
      {/* SKY-53: 出荷キャンセル（台目セルのクリックで遷移） */}
      <Route path="/asphalt-cancel" component={CancelEdit} />
    </Layout>
  );
};
